import m from './module';

import { getProvisionalIdentifierForType } from '../util';

class DashboardNotificationService {
  constructor($q, $log, APIService, DataSyncService) {
    this.$q = $q;
    this.$log = $log;
    this.APIService = APIService;
    this.DataSyncService = DataSyncService;

    this._notifications = [];
  }

  get notifications() {
    return this._notifications;
  }

  getOrCreateNotificationById(id) {
    const foundNotification = this.getNotificationById(id);
    if (foundNotification) {
      return foundNotification;
    } else {
      const newNotification = { id };
      return this.addNotification(newNotification);
    }
  }

  getNotificationById(id) {
    const foundIdx = this.findNotificationIndexById(id);
    if (foundIdx > -1) {
      return this.notifications[foundIdx];
    }
    return null;
  }

  addNotification(notification) {
    if (!notification.id) {
      notification.id = getProvisionalIdentifierForType('DashboardNotification');
    }
    if (!notification.type) {
      notification.type = 'info';
    }
    if (!notification.onClick) {
      notification.onClick = null;
    }
    const existingNotificationIdx = this.findNotificationIndexById(notification.id);
    if (existingNotificationIdx > -1) {
      // Replace previous notification
      this.notifications[existingNotificationIdx] = notification;
    } else {
      // Append new notification
      this.notifications.push(notification);
    }
    return notification;
  }

  removeNotification(notification) {
    return this.removeNotificationById(notification.id);
  }

  removeNotificationById(id) {
    const idx = this.findNotificationIndexById(id);
    if (idx > -1) {
      this.notifications.splice(idx, 1);
      return true;
    }
    return false;
  }

  findNotificationIndexById(id) {
    return this.notifications.findIndex(notification => notification.id === id);
  }

  clearTranslatedTextForAllNotifications() {
    this.notifications.forEach(notification => {
      notification.translatedText = null;
    });
  }
}

export default DashboardNotificationService;

m.service('DashboardNotificationService', DashboardNotificationService);
